import { render } from "./VirtualRedTagManualEntry.vue?vue&type=template&id=c1b8b766&scoped=true&ts=true"
import script from "./VirtualRedTagManualEntry.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagManualEntry.vue?vue&type=script&lang=ts"

import "./VirtualRedTagManualEntry.vue?vue&type=style&index=0&id=c1b8b766&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b8b766"]])

export default __exports__